import { AlertCircle } from 'lucide-react';
import { Button } from './Button';

/**
 * Error state for a data region — reference §8 requires one on every region. Always offers
 * a retry: an error the user can do nothing about is a dead end. The correlation id is
 * shown so support can trace the exact request.
 */
export function ErrorState({
  message,
  correlationId,
  onRetry,
}: {
  message: string;
  correlationId?: string | null;
  onRetry?: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-3 px-6 py-14 text-center"
    >
      <AlertCircle className="h-5 w-5 text-red-500" aria-hidden="true" />
      <div>
        <p className="text-sm text-slate-700">{message}</p>
        {correlationId ? (
          <p className="mt-1 font-mono tabular-nums text-xs text-slate-400">
            Reference {correlationId}
          </p>
        ) : null}
      </div>
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  );
}
